// The purpose of all of the "...-em" is to make the dimensions/sizes of the side bar
// and all of its related features to be the same across the products.
// (In AVGen & Graphics Engine there are media querys which changes the font size of the root
// element, therefore the "rem" unit isn't appropriate here as the side bar dimensions aren't
// unified between different procudts or screen dimensions

import { IconButton, styled, Theme } from "@mui/material";

interface StyledSidebarMenuButtonProps {
  isSelected?: boolean;
}

const getSelectedStyles = (theme: Theme) => `
  background-color: ${theme.wsc.palette.neutral[600]};
  opacity: 1;
`;

export const StyledSidebarMenuButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "isSelected",
})<StyledSidebarMenuButtonProps>`
  display: flex;
  flex-direction: column;
  // gap: ${(props) => props.theme.wsc.spacing[0]};
  gap: 0.286em;
  color: ${(props) => props.theme.wsc.palette.neutral[0]};
  // padding: ${(props) => `${props.theme.wsc.spacing[0]} 0`};
  padding: 0.286em 0;
  // border-radius: ${(props) => props.theme.wsc.radius.m};
  border-radius: 0.286em;
  opacity: 0.8;
  // width: ${(props) => props.theme.wsc.size.xxl};
  width: 2.286em;

  &&:focus {
    outline: 0;
  }

  :hover {
    background-color: ${(props) => props.theme.wsc.palette.neutral[700]};
  }

  :active {
    ${(props) => getSelectedStyles(props.theme)};
  }

  ${(props) => props.isSelected && getSelectedStyles(props.theme)}

  span {
    ${(props) => props.theme.wsc.typography.body3};
    font-size: 0.5em;
  }
`;
